export default __webpack_public_path__ + "static/media/inf.fa96bfa9.png";